import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileDownload: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-download, document"><path d="M8.25 21.25H4.75V2.75H12.75L19.25 9.25V21.25H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 13.75V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M14.5 17.5L12 20L9.5 17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.25073V9.2499H18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileDownload;
